<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { Country } from '$types';

  defineProps({
    countries: { type: Array as PropType<Country[]>, required: true },
  });
</script>
<template>
  <div class="register">
    <SfTile large>
      <template #title>
        <p class="account-heading">{{ $t('Masz już konto?') }}</p>
      </template>
      <SfButton :href="route('web.account.session.create')">
        {{ $t('Zaloguj się') }}
      </SfButton>
    </SfTile>
    <SfTile large class="register__new-account">
      <template #title>
        <p class="account-heading">{{ $t('Nowe konto') }}</p>
      </template>
      <AccountSignUpForm :countries="countries" />
    </SfTile>
  </div>
</template>
<style lang="scss">
  @use "$assets/mixins/media";

  .register {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    align-items: flex-start;
    gap: 4rem;
    max-width: 1200px;
    margin: 100px auto;
  }

  @include media.query(lg) {
    .register {
      grid-template-columns: 1fr;
      gap: 1rem;
      margin: 1rem 0 2rem;

      &__new-account {
        order: -1;
      }

      .tile__content {
        padding: 1.25rem 0.625rem;

        .tile__header {
          justify-content: center;
        }
      }
    }
  }
</style>
